import PageShell from "@/components/founding/PageShell";
import Pricing from "@/components/founding/Pricing";
import SeoHead from "@/components/seo/SeoHead";
import {
    PAGE_SEO,
    softwareApplicationSchema,
    organizationSchema,
    faqSchema,
} from "@/lib/seo";

const PRICING_FAQS = [
    {
        q: "What is a Standard Retrofit Unit (SRU)?",
        a: "An SRU is the metered unit consumed when you export a finalized watermarked report from FSRS. One SRU roughly maps to an ordinary-hazard zone of 5,000 sf. Larger or more complex projects scale to multiple SRUs.",
    },
    {
        q: "What happens after the included SRUs are used?",
        a: "Additional usage is measured in SRUs.",
    },
    {
        q: "Is Founding Beta a subscription?",
        a: "Yes. Founding Beta is $249/month and includes 15 SRUs each month. Starter is $99/month. Professional and Firm are coming soon.",
    },
    {
        q: "Are FSRS outputs ready for permit submission?",
        a: "No. FSRS is an AI fire suppression design assistant. Every export is preliminary, watermarked, and requires licensed Professional Engineer review, modification, and stamping before any permit submission, fabrication, or installation.",
    },
];

export default function PricingPage() {
    return (
        <PageShell>
            <SeoHead
                {...PAGE_SEO.pricing}
                jsonLd={[
                    softwareApplicationSchema(),
                    organizationSchema(),
                    faqSchema(PRICING_FAQS),
                ]}
            />
            <Pricing />
        </PageShell>
    );
}
